// used by cph-epi\src\Cph.Website\Views\Blocks\HandicapParkingBlock\Index.cshtml
import { ActivateSpinner, DeactivateSpinner } from "./Spinner"
import { CreateEvent } from "./_polyfills"
import * as tracking from "../booking/helpers/tracking"

export function HandicapParking() {
  init()
}

function init() {
  const el = document.getElementById("handicapLicenseForm")
  if (el) {
    el.addEventListener("click", () => PostHandicapLicenseForm(el.dataset.id, el.dataset.culturecode))
  }
}

function PostHandicapLicenseForm(id, lang) {
  ActivateSpinner()
  const name = document.getElementById("handiname").value
  const day = document.getElementById("handiday").value
  const month = document.getElementById("handimonth").value
  const year = document.getElementById("handiyear").value
  const code = document.getElementById("handicode").value
  const postdata = {
    Name: name,
    Day: day,
    Month: month,
    Year: year,
    Code: code,
    Id: id,
    Lang: lang,
  }

  fetch("/HandicapParking/Form/PostForm", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(postdata),
  })
    .then((response) => response.text())
    .then((data) => {
      if (data) {
        document.getElementById("handiholder").innerHTML = data
        window.dispatchEvent(CreateEvent("forms:init"))
      }
      tracking.trackParkingEngagementClick("submit", "parking for disabled")
    })
    .finally(() => {
      DeactivateSpinner()
    })
}

HandicapParking()
